import Vue from 'vue'
import Vuex from 'vuex'
import '../toasts/msgs'

import agendamento from './modules/agendamento'
import authUser from './modules/auth'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules:{
    agendamento,
    authUser,
  },
  state: {
   
  },
  mutations: { //syncrono
    
  },
  actions: {
    
  },

  getters:{
    
  }
})

export default store;